<ng-container *ngIf="account">
  <div class="stat">
    <i class="fa {{ account.card_brand | cardIcon }}"></i>
    {{ account.card_last_four ? '•••• •••• •••• ' + account.card_last_four : 'No Card on File' }}
  </div>
</ng-container>
